export default __webpack_public_path__ + "static/media/prize-2.388406bc.webp";